export enum GdprStatus {
  NO_CONSENT = 'no_consent',
  CONSENT_REQUESTED = 'consent_requested',
  CONSENT_GIVEN = 'consent_given',
  EXPIRING = 'expiring',
  EXPIRED = 'expired',
}
export type TGdprStatus = `${GdprStatus}`;
export enum GdprConsentRequestKind {
  MANUAL = 'manual',
  AUTO = 'auto',
}
